/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceTicketDetails {
    getFixupPrototypeFunction() { return FreshserviceTicketDetails.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceTicketDetails>): FreshserviceTicketDetails {
        let obj = Object.assign(new FreshserviceTicketDetails(), model);
        FreshserviceTicketDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceTicketDetails>): FreshserviceTicketDetails {
        if (!model) return null;
        return FreshserviceTicketDetails.newInstance(<FreshserviceTicketDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceTicketDetails) {
        if (!obj) return;

        models.FreshserviceTicketDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceTicketDetails): boolean {
        Object.setPrototypeOf(obj, FreshserviceTicketDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.source === undefined) {
            this.source = 0;
        }
        if (this.urgency === undefined) {
            this.urgency = 0;
        }
        if (typeof this.due_by === "string") {
            this.due_by = new Date(<string><any>this.due_by);
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.attachments) {
            for (let val of this.attachments) {
                models.FreshserviceTicketAttachment.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique Id
     */
    ticket_id: string;

    /**
     * Subject
     */
    subject: string;

    /**
     * Description of the ticket
     */
    description: string;

    /**
     * Requester Email
     */
    email: string;

    /**
     * Status
     */
    status: string;

    /**
     * Source
     */
    source: number;

    /**
     * Urgency
     */
    urgency: number;

    /**
     * Resolution Notes
     */
    resolution_notes: string;

    /**
     * Priority
     */
    priority: string;

    /**
     * Ticket Type
     */
    ticket_type: string;

    /**
     * Workspace Id
     */
    workspace_id: string;

    /**
     * Department
     */
    department: string;

    /**
     * Group Id
     */
    group_id: string;

    /**
     * Category
     */
    category: string;

    /**
     * Sub Category
     */
    sub_category: string;

    item_category: string;

    /**
     * Responder Id
     */
    responder_id: string;

    /**
     * Requested for Id
     */
    requested_for_id: string;

    /**
     * To Emails
     */
    to_emails: Array<string>;

    /**
     * Forward Emails
     */
    fwd_emails: Array<string>;

    /**
     * CC Emails
     */
    cc_emails: Array<string>;

    /**
     * Reply CC Emails
     */
    reply_cc_emails: Array<string>;

    /**
     * Due By
     */
    due_by: Date;

    /**
     * Created At
     */
    created_at: Date;

    /**
     * Updated At
     */
    updated_at: Date;

    /**
     * Is Deleted
     */
    is_deleted: boolean;

    /**
     * Is Spam
     */
    is_spam: boolean;

    /**
     * Is Escalated
     */
    is_escalated: boolean;

    /**
     * Attachments Info
     */
    attachments: Array<models.FreshserviceTicketAttachment>;

}
